import { motion, useReducedMotion, useScroll, useSpring } from "framer-motion";
import { useEffect, useRef, useState } from "react";

const SECTION_ACCENTS = [
    { sel: "#top", color: "#7E35A8" },
    { sel: "#amenities", color: "#22B3A3" },
    { sel: "#who-is-it-for", color: "#2B5CAB" },
    { sel: "#gallery", color: "#7E35A8" },
    { sel: "#pricing", color: "#2B5CAB" },
    { sel: "#location", color: "#22B3A3" },
    { sel: "#book-demo", color: "#2B5CAB" },
    { sel: '[data-testid="final-cta-section"]', color: "#22B3A3" },
    { sel: '[data-testid="site-footer"]', color: "#16324F" },
];

export default function ScrollProgress() {
    const reduced = useReducedMotion();
    const { scrollYProgress } = useScroll();
    const smooth = useSpring(scrollYProgress, { stiffness: 120, damping: 28, mass: 0.4 });

    const [chime, setChime] = useState({ color: null, n: 0 });
    const lastRef = useRef(null);

    useEffect(() => {
        const sections = SECTION_ACCENTS.map((s) => ({ ...s, el: document.querySelector(s.sel) })).filter((s) => s.el);
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    const found = sections.find((s) => s.el === entry.target);
                    if (found && lastRef.current !== found.sel) {
                        lastRef.current = found.sel;
                        setChime((c) => ({ color: found.color, n: c.n + 1 }));
                    }
                });
            },
            { rootMargin: "-45% 0px -45% 0px" },
        );
        sections.forEach((s) => io.observe(s.el));
        return () => io.disconnect();
    }, []);

    return (
        <motion.div
            aria-hidden="true"
            data-testid="scroll-progress"
            className="fixed inset-x-0 top-0 z-[60] h-[3px] origin-left"
            style={{
                scaleX: reduced ? scrollYProgress : smooth,
                backgroundImage: "linear-gradient(90deg, #7E35A8 0%, #2B5CAB 50%, #22B3A3 100%)",
            }}
        >
            {chime.color && !reduced && (
                <motion.span
                    key={chime.n}
                    className="absolute inset-0 block"
                    style={{ background: chime.color, boxShadow: `0 0 14px ${chime.color}` }}
                    initial={{ opacity: 0, scaleY: 1 }}
                    animate={{ opacity: [0, 0.95, 0], scaleY: [1, 2.6, 1] }}
                    transition={{ duration: 0.7, ease: "easeOut" }}
                />
            )}
        </motion.div>
    );
}
